var WHATSAPP_ENDPOINT = "https://api.whatsapp.com/send?phone=";
export var getWhatsappEndpoint = function () { return WHATSAPP_ENDPOINT; };
//# sourceMappingURL=getWhatsappEndpoint.js.map